// The existing Shopify cart form remains responsible for checkout.
let pending = 0;
const sync = () => document.querySelectorAll('vadrouk-cart-checkout').forEach(el => {
  const busy = pending > 0 || !!document.querySelector('cart-items-component.cart-items-disabled');
  el.querySelector('button').disabled = busy;
  el.setAttribute('aria-busy', String(busy));
});
import('@shopify/events').then(({ StandardEvents }) => {
  for (const name of [StandardEvents.cartLinesUpdate, StandardEvents.cartDiscountUpdate]) {
    document.addEventListener(name, event => {
      pending++; sync();
      Promise.resolve(event.promise).catch(() => {}).finally(() => { pending--; requestAnimationFrame(sync); });
    }, true);
  }
});
if (!customElements.get('vadrouk-cart-checkout')) customElements.define('vadrouk-cart-checkout', class extends HTMLElement {
  connectedCallback() {
    sync();
    this.cartObserver = new MutationObserver(sync);
    const cartItems = document.querySelector('cart-items-component');
    if (cartItems) this.cartObserver.observe(cartItems, { attributes: true, attributeFilter: ['class'] });
    const updateOffset = () => {
      const frame = document.querySelector('#PBarNextFrame, #preview-bar-iframe, #shopify-preview-bar-iframe, iframe[title="Shopify Preview Bar"]');
      const rect = frame?.getBoundingClientRect();
      const fullPreviewFrame = frame?.id === 'PBarNextFrame' && rect?.height >= innerHeight - 2;
      const offset = fullPreviewFrame ? 64 : rect && rect.height < 150 && rect.width > innerWidth * .7 && Math.abs(rect.bottom - innerHeight) < 3 ? rect.height : 0;
      this.style.setProperty('--vcc-preview-offset', `${offset}px`);
      document.documentElement.style.setProperty('--vcc-preview-offset', `${offset}px`);
      if (this.offset !== offset) {
        this.offset = offset;
        this.checkoutObserver?.disconnect();
        const checkout = document.querySelector('.cart-page #checkout');
        if (checkout) {
          this.checkoutObserver = new IntersectionObserver(entries => {
            this.hidden = entries[0].isIntersecting && entries[0].intersectionRatio > .9;
          }, { rootMargin: `0px 0px -${offset + 80}px 0px`, threshold: [.9] });
          this.checkoutObserver.observe(checkout);
        }
      }
      if (frame && frame !== this.frame) { this.resize?.disconnect(); this.frame = frame; this.resize = new ResizeObserver(updateOffset); this.resize.observe(frame); }
    };
    this.updateOffset = updateOffset;
    updateOffset();
    this.mutation = new MutationObserver(updateOffset);
    this.mutation.observe(document.body, { childList: true });
    window.addEventListener('resize', updateOffset);
  }
  disconnectedCallback() { this.resize?.disconnect(); this.mutation?.disconnect(); this.cartObserver?.disconnect(); this.checkoutObserver?.disconnect(); window.removeEventListener('resize', this.updateOffset); }
});
